/* eslint-disable no-param-reassign */
import surveyApi from '@/apis/survey';

export default {
  namespaced: true,
  state: () => ({
    surveyContentsFetched: false,
    surveyContents: {},
  }),
  mutations: {
    init(state, payload) {
      state.surveyContents = payload;
      state.surveyContentsFetched = true;
    },
  },
  actions: {
    async init({
      commit,
    }) {
      const r = await surveyApi.getAllSurveyContents();
      commit('init', r);
    },
  },
  getters: {
    surveyContentsFetched: (state) => state.surveyContentsFetched,
    surveyContents: (state) => state.surveyContents,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/survey.js